import React from 'react';
import Faq from '../Faq';
import FaqHeader from '../FaqHeader';
import Footer from '../Footer';

const FaqPage = () => (
  <>
    <FaqHeader />
    <Faq />
    <Footer />
  </>
);

export default FaqPage;
